export default __webpack_public_path__ + "static/stacked-column-c6d8d05f6fff42f8a383124ae51533d4.png";